import { VIDEO_APPID } from '@/login/login';
import { LOGIN_TYPE, LoginInfo } from '@/store/modules/user';
import { getLoginApi } from '@/utils/getApiDomain';

import { CgiTrpcResp } from './cgi';
import { API_PREFIX, request } from './request';

const APP_LOGIN_API = getLoginApi();
export const APP_ID = 'wx35504e2aa20c2bbf';
export const QQ_APP_ID = '102800978';

export async function loginVideo(tokenCode: string, guid: string, loginType: LOGIN_TYPE, phone?: {
  phone: string,
  ticket: string,
}) {
  const url = `${APP_LOGIN_API}/trpc.video_ucenter.auth_center.AuthCenter/Login?video_appid=${VIDEO_APPID}`;
  const params = {
    [LOGIN_TYPE.WX]: {
      refreshValue: '',
      tokenAppid: APP_ID, // 微信appid
      tokenCode: '', // 微信code
      tokenUin: 0,
      tokenValue: tokenCode,
      tokenid: '',
      thirdAppid: '',
      guid,
    },
    [LOGIN_TYPE.QQ]: {
      token_key_type: 11,
      token_appid: QQ_APP_ID,
      token_value: tokenCode,
    },
    [LOGIN_TYPE.PHONE]: {
      token_key_type: 34,
      // "token_appid": "先不传试试",
      tokenid: '+86',
      token_value: phone?.phone,
      token_code: phone?.ticket,
    },
  }[loginType];

  const res = await request<CgiTrpcResp<LoginInfo>>(url, {
    method: 'POST',
    needTransform: false,
    body: {
      dev_info: {
        guid,
      },
      login_token_list: [
        {
          ...params,
        },
      ],
      signInfo: {}, // 安全加固参数
    },
  });
  return res;
}

export async function refreshLogin({
  vuser,
  vsession_key,
  refresh_token,
  access_token,
  openid,
  guid,
  loginType,
}:
{ [key: string]: string | boolean }) {
  const url = `${APP_LOGIN_API}/trpc.video_ucenter.auth_center.AuthCenter/RefreshToken?video_appid=${VIDEO_APPID}`;
  if (!(vuser && vsession_key)) {
    return {
      ret: -1,
      msg: '缺少必要参数',
      data: null,
      code: -1,
    };
  }

  const params = {
    [LOGIN_TYPE.QQ]: {
      login_token_list: [
        {
          token_appid: QQ_APP_ID,
          token_code: '',
          token_key_type: 9,
          token_uin: Number(vuser),
          token_value: vsession_key,
        },
        {
          refresh_value: refresh_token,
          token_appid: QQ_APP_ID,
          token_key_type: 10,
          token_value: access_token,
          tokenid: openid,
        },
      ],
    },
    [LOGIN_TYPE.WX]: {
      login_token_list: [
        {
          token_appid: APP_ID,
          token_code: '',
          token_key_type: 9, // 视频vuid类型
          token_uin: Number(vuser), // 视频vuid
          token_value: vsession_key, // 视频票据
        },
        {
          refresh_value: refresh_token, // refresh_token
          token_appid: APP_ID, // 微信appid
          token_key_type: 100, // 微信code刷新100, qq code刷新10
          token_value: access_token, // access_token
          tokenid: openid, // openid
        },
      ],
    },
    [LOGIN_TYPE.PHONE]: {
      login_token_list: [
        {
          token_key_type: 117,
        },
        {
          token_key_type: 9,
          token_uin: Number(vuser),
          token_value: vsession_key,
        },
      ],
    },
  }[loginType as LOGIN_TYPE];

  const res = await request<CgiTrpcResp<LoginInfo>>(url, {
    method: 'POST',
    needTransform: false,
    body: {
      dev_info: {
        guid,
      },
      ...params,
      signInfo: {}, // 安全加固参数
    },
  });
  return res;
}


export async function loginOutVideo({
  vuser,
  vsession_key,
  refresh_token,
  access_token,
  openid,
  guid,
  loginType = LOGIN_TYPE.WX,
}:
{ [key: string]: string }) {
  const url = `${APP_LOGIN_API}/trpc.video_ucenter.auth_center.AuthCenter/Logout?video_appid=${VIDEO_APPID}`;
  const params = {
    [LOGIN_TYPE.QQ]: {
      login_token_list: [
        {
          token_appid: QQ_APP_ID,
          token_code: '',
          token_key_type: 9,
          token_uin: Number(vuser),
          token_value: vsession_key,
        },
        {
          refresh_value: refresh_token,
          token_appid: QQ_APP_ID,
          token_key_type: 10,
          token_value: access_token,
          tokenid: openid,
        },
      ],
    },
    [LOGIN_TYPE.WX]: {
      login_token_list: [
        {
          token_appid: APP_ID,
          token_code: '',
          token_key_type: 9, // 视频vuid类型
          token_uin: Number(vuser), // 视频vuid
          token_value: vsession_key, // 视频票据
        },
        {
          refresh_value: refresh_token, // refresh_token
          token_appid: APP_ID, // 微信appid
          token_key_type: 100, // 微信code刷新100, qq code刷新10
          token_value: access_token, // access_token
          tokenid: openid, // openid
        },
      ],
    },
    [LOGIN_TYPE.PHONE]: {
      login_token_list: [
        {
          token_key_type: 117,
        },
        {
          token_key_type: 9,
          token_uin: Number(vuser),
          token_value: vsession_key,
        },
      ],
    },
  }[loginType as LOGIN_TYPE];
  const res = await request<CgiTrpcResp<LoginInfo>>(url, {
    method: 'POST',
    needTransform: false,
    body: {
      dev_info: {
        guid,
      },
      ...params,
      signInfo: {}, // 安全加固参数
    },
  });
  return res;
}


// 防水墙 - 获取验证码
// https://testvip.video.qq.com/fcgi-bin/comm_cgi?name=spp_hlw_phone_login&cmd=25460&otype=xjson

export const sppHlwPhoneLogin = async (data: {
  phone: string,
  cookie: string,
}) => {
  try {
    const url = `${API_PREFIX}/phone_login`;
    const res = await request<CgiTrpcResp<LoginInfo>>(url, {
      method: 'POST',
      needTransform: false,
      body: {
        area_code: '+86',
        phone: data.phone,
        from: 'nova_phone_login',
        // cookie: data.cookie,
      },
    });

    return {
      ...res,
      data: JSON.parse(res?.data as string || '{}'),
    } as unknown as {
      data: {
        ret: number,
        msg: string,
      }
    };
  } catch (error) {
    return { data: { ret: -1, msg: '获取验证码失败,请重试' } };
  }
};
